import request from "@/config/axios"

export interface RoomStateItemVO {
  id: number | string
  roomNo: string
  floor: number
  roomState: number
  statusName: string
  statusColor: string
  spuName?: string
  shopId: number | string
  shopName?: string
  spuId?: number | string
  guestName?: string
  guestPhone?: string
  gender?: number
  channel?: string
  channelLabel?: string
  marketType?: string
  isLongTerm?: boolean
  isRenewal?: boolean
  remark?: string
  orderId?: number | string
  checkInDate?: string
  checkOutDate?: string
}

export interface RoomStateBoardRespVO {
  floor: number
  rooms: RoomStateItemVO[]
}

export interface DimensionCountVO { value: any; label: string; count: number; total?: number }
export interface FilterStatsVO { floors: DimensionCountVO[]; roomTypes: DimensionCountVO[]; roomStates: DimensionCountVO[]; channels: DimensionCountVO[]; markets: DimensionCountVO[] }
export interface AccessibleHotelsVO { switchable: boolean; hotels: Array<{ id: number | string; name: string }> }

const serializeBoardFilters = (params: Record<string, any>) => Object.fromEntries(
  Object.entries(params).map(([key, value]) => [key, Array.isArray(value) ? value.join(',') : value])
)

export const getRoomStateBoard = (params: any) => {
  return request.get<RoomStateBoardRespVO[]>({ url: "/hotel/room-state-board/board", params: serializeBoardFilters(params) })
}

export const updateRoomState = (roomId: number | string, roomState: number) => {
  return request.put<boolean>({ url: `/hotel/room-state-board/update-state?roomId=${roomId}&roomState=${roomState}` })
}

export const getFilterStats = (shopId: number | string, filters: Record<string, any> = {}) =>
  request.get<FilterStatsVO>({ url: '/hotel/room-state-board/filter-stats', params: serializeBoardFilters({ shopId, ...filters }) })

export const getRoomStateByDate = (shopId: number | string, date: string) =>
  getRoomStateBoard({ shopId, date })

export const getAccessibleHotels = () =>
  request.get<AccessibleHotelsVO>({ url: '/hotel/room-state-board/accessible-hotels' })
